import React from 'react';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import { USER_TAG_TONES } from '../user.constants';
import styles from './styles/user-header-tag.module.scss';

/**
 * Tag chip rendered next to the user name in the page header
 * (Figma 5747:1691). Three tones cover the three chip families the
 * Figma uses:
 *  - `primary` — work type ("SALARIED" / "HOURLY"), soft blue fill.
 *  - `neutral` — payroll system ("PAYCOM"), light grey fill.
 *  - `info`    — pay period range, blue-100 fill.
 *
 * Tone is purely cosmetic — the consumer decides which value maps to
 * which tone. The label is uppercased here so callers can pass mixed
 * case (e.g. "Salaried") without leaking styling concerns.
 *
 * @param {Object} props
 * @param {string} props.label
 * @param {(typeof USER_TAG_TONES)[keyof typeof USER_TAG_TONES]} [props.tone]
 */
function UserHeaderTag({ label, tone = USER_TAG_TONES.NEUTRAL }) {
    const safeLabel = (label || '').toString().toUpperCase();
    return (
        <Text
            as={TextAs.SPAN}
            size={TextSizes.EXTRA_SMALL}
            className={`${styles.chip} ${styles[`chip_${tone}`] || styles.chip_neutral}`}
        >
            {safeLabel}
        </Text>
    );
}

export default UserHeaderTag;
